import { PageKey } from '../enums/pageKey';

export const BUTTON_TEXT = {
  LESSON_PLAN: 'Prepare Lesson Plan!',
  UNIT_PLAN: 'Prepare Unit Plan!',
  ACTIVITY: 'Prepare Activity!',
  QUIZ_MAKER: 'Prepare Quiz!',
  SUMMATIVE_TEST: 'Prepare Summative Test!',
  TOPIC_EXPLORER: 'Explore the Topic!',
  OBJECTIVE: 'Prepare Objectives!',
  ANALOGY: 'Prepare Analogy!',
  ENERGIZER: 'Prepare Energizer!',
  DLL: 'Prepare Daily Lesson Log!',
  SUBJECT_EXTENSION: 'Prepare Learnings Across Curriculum!',
  CATCH_UP_FRIDAYS: 'Prepare Catch-Up Fridays!',
  DAILY_LESSON_LOG: 'Prepare Daily Lesson Log!',
  CEREBRO_LESSON_PLAN: 'Prepare Cerebro Lesson Plan!',
  ELIF: "Explain Like I'm 5!",
  PHOTO_BOOTH: 'Prepare Photo Booth!',
  PPT_MAKER: 'Prepare PPT!',
  GENERIC_UNPACKING: 'Generate Learning Competency!',
  IPLAN: 'Continue to IPlan Features!',
  IPLAN_OBJECTIVE: 'Prepare Objectives!',
};

export const PAGE_BUTTON_TEXT: Partial<Record<PageKey, string>> = {
  [PageKey.lessonPlan]: BUTTON_TEXT.LESSON_PLAN,
  [PageKey.unitPlan]: BUTTON_TEXT.UNIT_PLAN,
  [PageKey.objective]: BUTTON_TEXT.OBJECTIVE,
  [PageKey.iplanObjective]: BUTTON_TEXT.IPLAN_OBJECTIVE,
  [PageKey.quizMakerSingle]: BUTTON_TEXT.QUIZ_MAKER,
  [PageKey.subjectExtention]: BUTTON_TEXT.SUBJECT_EXTENSION,
  [PageKey.analogyContextualizer]: BUTTON_TEXT.ANALOGY,
  [PageKey.activities]: BUTTON_TEXT.ACTIVITY,
  [PageKey.catchUpFridays]: BUTTON_TEXT.CATCH_UP_FRIDAYS,
  [PageKey.dailyLessonLog]: BUTTON_TEXT.DAILY_LESSON_LOG,
  [PageKey.cerebroLessonPlan]: BUTTON_TEXT.CEREBRO_LESSON_PLAN,
  [PageKey.summativeTest]: BUTTON_TEXT.SUMMATIVE_TEST,
  [PageKey.topicExplorer]: BUTTON_TEXT.TOPIC_EXPLORER,
  [PageKey.energizer]: BUTTON_TEXT.ENERGIZER,
  [PageKey.elif]: BUTTON_TEXT.ELIF,
  [PageKey.photoBooth]: BUTTON_TEXT.PHOTO_BOOTH,
  [PageKey.pptMaker]: BUTTON_TEXT.PPT_MAKER,
  [PageKey.genericUnpacking]: BUTTON_TEXT.GENERIC_UNPACKING,
  [PageKey.iplan]: BUTTON_TEXT.IPLAN,
};
